import { v4 as uuidv4 } from "uuid";
import { OOCheckItemModifier } from "./oo-check-item-modifier";
export class OOCheckItem {
	key: number;
	name: string;
	displayName: string;
	qty: number;
	price: number;
	taxable: boolean;
	modifiers: OOCheckItemModifier[] = [];
	guestCheckName: string;
	kitchenComment: boolean;
	priceNumber: number;
	priceNumberName: string;
	outOfStock: boolean;
	canvasKey: number;
	locked: boolean;
	deliveryFee: boolean;
	originatingCanvasKey: number;
	removed: boolean;
	unsent: boolean;
	uuid: string = uuidv4();

	public constructor(init?: Partial<OOCheckItem>) {
		Object.assign(this, init);
	}
}
